__turbopack_context__.v({
  "empty-state": "SearchEmptyState-module-scss-module__KvSAmG__empty-state",
  "icon": "SearchEmptyState-module-scss-module__KvSAmG__icon",
});
